import React, { createContext, useContext, useState } from "react";
import { getTokenApi } from "../services/Api/login";
import { apiCredentials } from "../services/Config";

export const AuthContext = createContext({})

export default function AuthProvider({ children }) {
    const [isSignUp, setIsSignUp] = useState(false)
    const [tokenApi, setTokenApi] = useState("")
    const [tokenUser, setTokenUser] = useState("")
    const [emailUser, setEmailUser] = useState("")
    const [roleUser, setRolelUser] = useState("")
    const [isFirstLogin, setIsFirstLogin] = useState(true)
    const [loginType, setLoginType] = useState(null);

    const getNewTokenApi = async () => {
        jsonToken = await getTokenApi(apiCredentials)
        setTokenApi(jsonToken.token)
        return jsonToken.token;
    };

    return <AuthContext.Provider value={{
        isSignUp, setIsSignUp,
        tokenApi, setTokenApi,
        tokenUser, setTokenUser,
        emailUser, setEmailUser,
        isFirstLogin, setIsFirstLogin,
        getNewTokenApi, roleUser,
        setRolelUser,
        loginType, setLoginType
    }}>
        {children}
    </AuthContext.Provider>
}